import api from "./api";  

export interface UploadBrandImageResult {
  success: boolean;
  logoUrl: string; // Backend'den gelen yeni logo yolu
}
  
/**
 * Marka logosunu sunucuya yükler
 */
export const uploadBrandLogoToServer = async (
  file: File, 
  brandId: number
): Promise<UploadBrandImageResult> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('brandId', brandId.toString());

  // Backend rotamız: POST /brand-images/upload
  const response = await api.post<UploadBrandImageResult>('/brand-images/upload', formData); 
  return response.data;
};

/**
 * Marka logosunu sunucudan siler
 */
export const deleteBrandLogoFromServer = async (brandId: number): Promise<boolean> => {
  try { 
    // Backend rotamız: DELETE /brand-images/delete?brandId=123
    const response = await api.delete(`/brand-images/delete?brandId=${brandId}`);
    
    return response.status === 200;
  } catch (error) {
    console.error("Marka logosu silme hatası:", error);
    return false;
  }
};